import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
    updateAdventureCardApi as updateCardApi,
    showAdventureCardApi as showCardApi,
    clearEditedAdventureCard,
} from './adventureCardSlice';
import { schema } from './adventure.yup';
import { FORM_GROUPS } from './constants.adventure';
import FormTabManager from '~/pages/CardSaga/components/FormTabManager.jsx';
import { FormTabProvider } from '~/pages/CardSaga/components/providers/FormTabProvider';
import uploadImage from '~/api/uploadImage';

function AdventureUpdate() {
    const { id } = useParams();
    const {
        editedModel: initialValues,
        frontSides,
        backSides,
        allPictures,
    } = useSelector((state) => state.cardSaga.adventureCard);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formGroups = [...FORM_GROUPS]; //as I use formGroups.shift() (which mutate the original `formGroups`) at `FormTabProvider.jsx` => `formGroups` must be cloned here else so that it is not be shift() again on next visit.
    const cardInformation = formGroups.shift();

    const formSubmit = async (values, formikBag) => {
        let pictureAttributeNames = [];
        for(let picture of allPictures) {
            if(!picture.includes('template'))
                pictureAttributeNames.push(picture)
        }
        await uploadImage(values, pictureAttributeNames, 'adventures');

        dispatch(updateCardApi({ navigate, id, values, formikBag }));
    };

    useEffect(() => {
        dispatch(showCardApi({ navigate, id }));

        return () => dispatch(clearEditedAdventureCard());
    }, []);

    return (
        <FormTabProvider
            initialValues={initialValues}
            schema={() => schema(true)}
            formGroups={formGroups}
            cardInformation={cardInformation}
            frontSides={frontSides}
            backSides={backSides}
            allPictures={allPictures}
        >
            <FormTabManager formSubmit={formSubmit} />
        </FormTabProvider>
    );
}

export default AdventureUpdate;
